import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { Field, FieldProps } from "formik";
import { FC } from "react";

interface SelectFormMUIProps {
  name: string;
  options: { label: string; value: string | number }[];
  placeholder?: string;
  dataT1?: string;
  boldTextIfActive?: boolean;
  label?: string;
  hasBackgroundWhenActive?: boolean;
  sx?: object;
  disabled?: boolean;
}

const SelectFormMUI: FC<SelectFormMUIProps> = ({
  name,
  options,
  placeholder,
  dataT1,
  label,
  sx,
  disabled = false,
}) => {
  return (
    <Field name={name}>
      {({ field, form, meta }: FieldProps) => {
        return (
          <FormControl fullWidth sx={{ mb: 2, ...sx }}>
            {label && (
              <InputLabel id={`${name}-label`} shrink>
                {label}
              </InputLabel>
            )}
            <Select
              {...field}
              displayEmpty
              labelId={`${name}-label`}
              label={label}
              sx={{ maxWidth: "512px" }}
              value={field.value || ""}
              onChange={(e: SelectChangeEvent<any>) =>
                form.setFieldValue(name, e.target.value)
              }
              data-t1={dataT1}
              disabled={disabled}
            >
              <MenuItem value="">
                {placeholder}
              </MenuItem>
              {options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
            {meta.touched && meta.error && (
              <Typography variant="caption" color="error">
                {meta.error}
              </Typography>
            )}
          </FormControl>
        );
      }}
    </Field>
  );
};

export default SelectFormMUI;
